import { render, staticRenderFns } from "./ProtocolTestRunner.vue?vue&type=template&id=c8fbd068&scoped=true"
import script from "./ProtocolTestRunner.vue?vue&type=script&lang=js"
export * from "./ProtocolTestRunner.vue?vue&type=script&lang=js"
import style0 from "./ProtocolTestRunner.vue?vue&type=style&index=0&id=c8fbd068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_304b4a1ebea3bd82ec282759e0696211/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fbd068",
  null
  
)

export default component.exports